import React from "react";

export default function About() {
  return (
    <div className="section container">
      <h2 className="section-title">About Lak Derana Cabs</h2>
      <p className="muted">
        Reliable Rides Since 2009. We’re a Kurunegala-born cab service with
        well-maintained vehicles, verified drivers, and transparent pricing.
      </p>
    </div>
  );
}
